import { createStore, applyMiddleware } from 'redux';
import reducer from '../reducers'
import carregarLotes from '../middlewares/lotes'
import logMiddleware from '../middlewares/log-middleware'
import corretos from '../middlewares/corretores'
import carregarInformacoes from '../middlewares/carregarInformacoes'
import carregarMapa from '../middlewares/carregarMapaPolys'
import ImagensMiddleWare from '../middlewares/imagens'
import requests from '../middlewares/requestQuee'
import paginas from '../middlewares/paginas'
import login from '../middlewares/login'

import {carregarCorretoresDoServer as carregarCorretoresAction} from '../actions/corretores'
import {carregarImagensDoServer as carregarImagensAction} from '../actions/imagem'
import {carregarInformacoesDoServer as carregarInformacoesAction} from '../actions/informacoes'
import {carregarLotesServer as carregarLotesAction} from '../actions/vendas'
import {carregarMapaDoServer} from '../actions/mapa'
import { carregarPaginas } from '../actions/paginas'

const store = createStore(reducer,
    applyMiddleware(logMiddleware, login, paginas, requests, ImagensMiddleWare, carregarLotes,corretos, carregarInformacoes, carregarMapa)
);

store.dispatch(carregarCorretoresAction())
store.dispatch(carregarInformacoesAction())
store.dispatch(carregarImagensAction())
store.dispatch(carregarLotesAction())
store.dispatch(carregarMapaDoServer())
store.dispatch(carregarPaginas())

export function state(){
    return store.getState();
}

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js